import React, { Component } from 'react'
import { Button, Form, Row } from 'react-bootstrap';
import moment from 'moment';
import LoaderBox from '../../../shared/loaders/loader.box';
import { apiRequest } from "../../../../functions/api";
import { pushNotification } from "../../../../functions/notifications";
import { ALL_CONST } from "../../../../constants/api";

const COLUMNS = [
    { key: 'id', label: 'ID' },
    { key: 'lastName', label: 'Nom' },
    { key: 'firstName', label: 'Prénom' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Téléphone' },
    { key: 'sejourName', label: 'Séjour' },
    { key: 'eventDate', label: 'Date du séjour' },
    { key: 'registrationDate', label: "Date d'inscription" },
];

class WaitlistExport extends Component {
    constructor(props) {
        super(props);

        this.onModelToggle = this.onModelToggle.bind(this);
        this.onSelectAll = this.onSelectAll.bind(this);
        this.onColumnChange = this.onColumnChange.bind(this);
        this.onExport = this.onExport.bind(this);

        this.state = {
            loading: false,
            loadingMess: "",
            loadingModels: true,
            models: [],      // [{ SID, name }]
            selectedSIDs: {},      // { [SID]: true/false }
            selectedColumns: COLUMNS.reduce((acc, col) => ({ ...acc, [col.key]: true }), {}),
            errors: {}
        };
    }

    componentDidMount() {
        this.loadModels();
    }

    loadModels() {
        this.setState({ loadingModels: true });
        apiRequest({
            url: '/sejours.models/get',
            data: { SIDS: ALL_CONST }
        }).then((res) => {
            if (res && res.data.http_code === 200 && res.data.status === 'success' && res.data.data) {
                const modelsData = res.data.data.models || {};

                const models = Object.entries(modelsData)
                    .map(([SID, model]) => ({ SID, name: model.name || SID }))
                    .sort((a, b) => a.name.localeCompare(b.name, 'fr'));

                // Tout coché par défaut
                const selectedSIDs = models.reduce(
                    (acc, { SID }) => ({ ...acc, [SID]: true }),
                    {}
                );

                this.setState({ models, selectedSIDs, loadingModels: false });
            } else {
                pushNotification({
                    type: "error",
                    title: "Erreur du serveur",
                    content: <p>Impossible de récupérer la liste des séjours.</p>,
                    icon: "mdi mdi-close"
                });
                this.setState({ loadingModels: false });
            }
        }).catch(() => {
            pushNotification({
                type: "error",
                title: "Erreur du serveur",
                content: <p>Impossible de récupérer la liste des séjours.</p>,
                icon: "mdi mdi-close"
            });
            this.setState({ loadingModels: false });
        });
    }

    onModelToggle(SID) {
        return (e) => {
            this.setState({
                selectedSIDs: { ...this.state.selectedSIDs, [SID]: e.target.checked },
                errors: {}
            });
        };
    }

    onSelectAll(allChecked) {
        return () => {
            const selectedSIDs = this.state.models.reduce(
                (acc, { SID }) => ({ ...acc, [SID]: allChecked }),
                {}
            );
            this.setState({ selectedSIDs, errors: {} });
        };
    }

    onColumnChange(key) {
        return (e) => {
            this.setState({
                selectedColumns: { ...this.state.selectedColumns, [key]: e.target.checked }
            });
        };
    }

    validate(selectedSIDsList, selectedColsList) {
        const errors = {};
        if (selectedSIDsList.length === 0) {
            errors.models = "Sélectionnez au moins un séjour.";
        }
        if (selectedColsList.length === 0) {
            errors.columns = "Sélectionnez au moins une colonne.";
        }
        return errors;
    }

    onExport(e) {
        e.preventDefault();
        if (this.state.loading) return;

        const selectedSIDsList = Object.keys(this.state.selectedSIDs).filter(
            (SID) => this.state.selectedSIDs[SID]
        );
        const selectedColsList = COLUMNS.map((c) => c.key).filter(
            (key) => this.state.selectedColumns[key]
        );

        const errors = this.validate(selectedSIDsList, selectedColsList);
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        this.setState({ errors: {}, loading: true, loadingMess: "Export en cours" });

        apiRequest({
            url: '/sejours.events.waitlist.export/get',
            data: { SIDS: selectedSIDsList, columns: selectedColsList },
            config: { responseType: 'blob' }
        }).then((res) => {
            this.setState({ loading: false });

            if (!res) {
                pushNotification({
                    type: "error",
                    title: "Erreur du serveur",
                    content: <p>Une erreur inconnue est survenue. Veuillez réessayer.</p>,
                    icon: "mdi mdi-close"
                });
                return;
            }

            const contentType = res.headers['content-type'] || "";
            if (contentType.includes('application/json')) {
                res.data.text().then((text) => {
                    let body = {};
                    try { body = JSON.parse(text); } catch (err) { /* ignore */ }
                    pushNotification({
                        type: "error",
                        title: "Export impossible",
                        content: <p>{body.status_code ? `Erreur : ${body.status_code}` : "Une erreur est survenue lors de l'export."}</p>,
                        icon: "mdi mdi-close"
                    });
                });
                return;
            }

            const disposition = res.headers['content-disposition'] || "";
            const match = disposition.match(/filename="?([^"]+)"?/);
            const filename = match ? match[1] : `listes-attente-${moment().format('YYYY-MM-DD')}.csv`;

            const url = window.URL.createObjectURL(res.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        });
    }

    render() {
        const { models, selectedSIDs, selectedColumns, loadingModels } = this.state;
        const allChecked = models.length > 0 && models.every(({ SID }) => selectedSIDs[SID]);
        const noneChecked = models.every(({ SID }) => !selectedSIDs[SID]);

        return (
            <div className="row">
                <div className="col grid-margin stretch-card">
                    <div className="card">
                        <LoaderBox show={this.state.loading} mess={this.state.loadingMess} className="card" inline>
                            <div className="card-body">
                                <h4 className="card-title">Exporter les listes d'attente</h4>
                                {loadingModels ? (
                                    <div className="text-center py-3">
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Chargement...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <Form className="col-12" onSubmit={this.onExport}>

                                        {/* Sélection des séjours (modèles) */}
                                        <Row className="mb-3">
                                            <Form.Group className="form-group full w-100">
                                                <Form.Label column className="p-0">Séjours</Form.Label>
                                                {models.length === 0 ? (
                                                    <p className="text-muted">Aucun séjour disponible.</p>
                                                ) : (
                                                    <>
                                                        <div className="m-0">
                                                            <button
                                                                type="button"
                                                                className="btn btn-link btn-sm p-0 mr-3"
                                                                onClick={this.onSelectAll(true)}
                                                                disabled={allChecked}
                                                            >
                                                                Tout sélectionner
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-link btn-sm p-0"
                                                                onClick={this.onSelectAll(false)}
                                                                disabled={noneChecked}
                                                            >
                                                                Tout désélectionner
                                                            </button>
                                                        </div>
                                                        <div className="flex row m-0">
                                                            {models.map(({ SID, name }) => (
                                                                <div className="form-check my-1 col-12" key={SID}>
                                                                    <label className="form-check-label text-muted">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input"
                                                                            checked={!!selectedSIDs[SID]}
                                                                            onChange={this.onModelToggle(SID)}
                                                                        />
                                                                        <i className="input-helper" />
                                                                        {name}
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </>
                                                )}
                                                {this.state.errors.models && (
                                                    <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                        {this.state.errors.models}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                        </Row>

                                        {/* Sélection des colonnes */}
                                        <Row>
                                            <Form.Group className="form-group">
                                                <Form.Label column className="p-0">Colonnes à exporter</Form.Label>
                                                <div className="flex row m-0">
                                                    {COLUMNS.map((column) => (
                                                        <div className="form-check my-1 col-3" key={column.key}>
                                                            <label className="form-check-label text-muted">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={!!selectedColumns[column.key]}
                                                                    onChange={this.onColumnChange(column.key)}
                                                                />
                                                                <i className="input-helper" />
                                                                {column.label}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                                {this.state.errors.columns && (
                                                    <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                        {this.state.errors.columns}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                        </Row>

                                        <div className="btn-container-inline-right mb-0">
                                            <Button
                                                variant="primary"
                                                type="submit"
                                                disabled={this.state.loading || models.length === 0}
                                            >
                                                <i className="mdi mdi-download" />Exporter en CSV
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </div>
                        </LoaderBox>
                    </div>
                </div>
            </div>
        );
    }
}

export default WaitlistExport;
